import React, { ComponentProps } from 'react'
import { Text } from 'components/Text'
import { Option } from './TextRadioOption.styles'

type RadioOptionOwnProps = ComponentProps<typeof Option>

export type TextRadioOptionProps = RadioOptionOwnProps & {
  label: string
  value: string
}

export const TextRadioOption = ({ label, value, ...rest }: TextRadioOptionProps) => {
  return (
    <Option id={value} value={value} {...rest}>
      <Text htmlFor={value} as="label" size="h4" weight="medium">
        {label}
      </Text>
    </Option>
  )
}

TextRadioOption.displayName = 'TextRadioOption'
